export var UserRole;
(function (UserRole) {
    UserRole["CLIENT"] = "client";
    UserRole["ATTORNEY"] = "attorney";
    UserRole["ADMIN"] = "admin";
    UserRole["ADMIN_LIMITED"] = "admin_limited";
})(UserRole || (UserRole = {}));
export const MainAdmin = [UserRole.ADMIN];
export const BothAdmins = [UserRole.ADMIN, UserRole.ADMIN_LIMITED];
